import React from "react";
import { TopTrendingEmptyStateTemplate } from "themes/administration/analytics/components";

function TopTrendingEmptyState(props) {
    return <TopTrendingEmptyStateTemplate {...props} />;
}

export default TopTrendingEmptyState;
